export default "__VITE_ASSET__B7U6zvsy__"